export default __webpack_public_path__ + "static/Team-Approach-to-Treating-IDA@2x-ceda7b4fb80c6f96f3aaf429ddebab51.png";